<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.90762 1.23379C8.40663 0.2534 7.59228 0.257409 7.09322 1.23379L0.203148 14.7247C-0.297842 15.7051 0.159626 16.5 1.22544 16.5H14.7754C15.8412 16.5 16.2967 15.7011 15.7977 14.7247L8.90762 1.23379ZM7 5.5C7 4.94772 7.44772 4.5 8 4.5C8.55228 4.5 9 4.94772 9 5.5L9 9.5C9 10.0523 8.55228 10.5 8 10.5C7.44772 10.5 7 10.0523 7 9.5L7 5.5ZM7 13.5C7 12.9477 7.44772 12.5 8 12.5C8.55228 12.5 9 12.9477 9 13.5C9 14.0523 8.55228 14.5 8 14.5C7.44772 14.5 7 14.0523 7 13.5Z"
    fill="currentColor"
  />
</template>
